import type { ReactNode } from 'react';

type ConditionalWrapperProps = {
  children: ReactNode;
  condition: boolean;
  wrapper: (children: ReactNode) => JSX.Element;
};

export const ConditionalWrapper = ({
  children,
  condition,
  wrapper,
}: ConditionalWrapperProps) => {
  return <>{condition ? wrapper(children) : children}</>;
};
